import { createTypedHooks } from 'easy-peasy'

import { StoreModel } from '.'

const store = createTypedHooks<StoreModel>()

export const useStore = store.useStoreState
export const useActions = store.useStoreActions
